import { readSettingList } from '@/api/point/read';
import { ResReadPointSettingsListType } from '@/types';
import { Box, Button, Card, CardContent, Divider } from '@mui/material';
import { useEffect, useState } from 'react';
import Header from '../../Header';
import { Tables } from '../../pools/table/Tables';
import { pointSettingListColumns } from '../table/ColumnData';
import { pointStatusFilter } from '@/lib/filter/stakingPoolState';
import { GridColDef } from '@mui/x-data-grid';

import { useNavigate } from 'react-router-dom';

export default function SettingList() {
  const [list, setList] = useState<ResReadPointSettingsListType[]>([]);
  const navigate = useNavigate();
  const addUserDashboardStakeListTableColumns: GridColDef[] = [
    ...pointSettingListColumns,
    {
      flex: 1,
      minWidth: 500,
      field: 'shortTxHash',
      headerName: '버튼',
      headerAlign: 'center',
      align: 'left',
      sortable: false,
      renderCell: (params) => (
        <>
          <Box display="flex" gap={1}>
            <Button
              variant="contained"
              color="primary"
              onClick={() =>
                navigate('/point-setting-detail', {
                  state: {
                    settingId: params.row.settingId,
                  },
                })
              }
            >
              상세
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                console.log(params);
                navigate('/point-setting-accumulated', {
                  state: {
                    settingId: params.row.settingId,
                  },
                });
              }}
            >
              목표 포인트
            </Button>

            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                console.log(params);
                navigate('/point-setting-achieve', {
                  state: {
                    settingId: params.row.settingId,
                  },
                });
              }}
            >
              추가 포인트
            </Button>

            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                console.log(params);
                navigate('/point-stake-setting', {
                  state: {
                    settingId: params.row.settingId,
                  },
                });
              }}
            >
              스테이킹 세팅
            </Button>
          </Box>
        </>
      ),
    },
  ];

  // const handleButtonClick = (aData: string) => {
  //   const src =
  //     process.env.NODE_ENV === 'development'
  //       ? `https://amoy.polygonscan.com/tx/${aData}`
  //       : `https://polygonscan.com/tx/${aData}`;
  //   window.open(src);
  // };

  useEffect(() => {
    (async () => {
      const re = await readSettingList();
      if (re.status !== 200) {
        return;
      }
      const list = re.data.map((item: ResReadPointSettingsListType, index: number) => ({
        ...item,
        index: item.settingId,
        statusFillter: pointStatusFilter(item.status),
      }));
      setList(list);
      console.log(re.data);
    })();
    return () => {};
  }, []);

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          overflow: 'auto',
          flex: 1,
          flexDirection: 'column',
          gap: { xs: '16px', sm: '0px' },
        }}
      >
        <Card>
          <Header title="세팅 리스트" />
          <Divider />
          <Box mb={2} />
          <Button
            variant="contained"
            onClick={() => {
              navigate('/point-setting');
            }}
          >
            신규 생성
          </Button>
          <CardContent>{list && <Tables list={list} columns={addUserDashboardStakeListTableColumns} />}</CardContent>
        </Card>
      </Box>
    </>
  );
}
